import React, { useEffect, useState } from "react";
import "./CreateCampaignTemplate.css";
import "./nameCampaign.css";
const SubmitAndResetButton = ({
  nextStep,
  currentStep,
  isDisabled,
  submitFinalFormData,
}) => {
  return (
    <div className="create-form-item">
      <div className="actions">
        <button
          className="back-button"
          disabled={currentStep === 1}
          onClick={() => nextStep(currentStep - 1)}
        >
          <svg
            className="w-6 h-6 text-white dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 12h14M5 12l4-4m-4 4 4 4"
            />
          </svg>
          Previous
        </button>
        <button
          className="continue-button"
          disabled={isDisabled}
          onClick={() => {
            currentStep < 5 && nextStep(currentStep + 1);
            currentStep === 5 && submitFinalFormData();
          }}
        >
          {currentStep === 5 ? (
            "Submit "
          ) : (
            <>
              Continue{" "}
              <svg
                className="w-6 h-6 text-white dark:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 12H5m14 0-4 4m4-4-4-4"
                />
              </svg>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default SubmitAndResetButton;
